import { CollectionDeletedEvent, CollectionRenamedEvent, RecordPropertiesUpdatedEvent, TransactionEvent } from '@indigohive/cogfy-types/events/transaction'
import { UUID } from '@indigohive/cogfy-types'
import { RunTransactionCommand } from '@indigohive/cogfy-types/endpoints/transactions'
import { BaseClient, BaseClientOptions } from './base-client'
import { SocketEvent } from '../socket'

export class TransactionsClient extends BaseClient {
  onCollectionDeleted: SocketEvent<CollectionDeletedEvent>
  onCollectionRenamed: SocketEvent<CollectionRenamedEvent>

  constructor (options: BaseClientOptions) {
    super(options)

    this.onCollectionDeleted = new SocketEvent(this.socket, 'collection_deleted')
    this.onCollectionRenamed = new SocketEvent(this.socket, 'collection_name_updated')
  }

  onRecordUpdated (recordId: UUID, listener: (event: RecordPropertiesUpdatedEvent) => void) {
    this.socket.emit('join', `record:${recordId}`)
    this.socket.on('record_updated', listener)
  }

  offRecordUpdated (recordId: UUID, listener: (event: RecordPropertiesUpdatedEvent) => void) {
    this.socket.emit('leave', `record:${recordId}`)
    this.socket.off('record_updated', listener)
  }

  onTransaction (collectionId: UUID, listener: (event: TransactionEvent) => void) {
    this.socket.emit('join', `collection:${collectionId}`)
    this.socket.on('transactions', listener)
  }

  offTransaction (collectionId: UUID, listener: (event: TransactionEvent) => void) {
    this.socket.emit('leave', `collection:${collectionId}`)
    this.socket.off('transactions', listener)
  }

  async create (
    data: RunTransactionCommand,
    signal?: AbortSignal
  ): Promise<void> {
    await this.axios.post('/transactions', data, { signal })
  }
}
